import { axiosClient } from './AxiosClient'
import dayjs from 'dayjs'

function listCalendar(currentDate, isAll, isGlobal, callback, errorCallback){
    let url = "/calendar/admin/list"

    let date = new Date(currentDate)
    let month = dayjs(date).format("M")
    let year = dayjs(date).format("YYYY")

    var bodyForm = new FormData()
    bodyForm.append("month", month)
    bodyForm.append("year", year)
    bodyForm.append("is_all", isAll)
    bodyForm.append("is_global", isGlobal)
    bodyForm.append('building_id', localStorage.getItem('building_id'))

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function getCalendar(eventId, callback, errorCallback){
    let url = "/calendar/admin/get"

    var bodyForm = new FormData()
    bodyForm.append("event_id", eventId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteCalendar(eventId, callback, errorCallback){
    let url = "/calendar/admin/delete"

    var bodyForm = new FormData()
    bodyForm.append("event_id", eventId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createCalendar(title, description, start, end, location, type, isGlobal, isAllday, isRepeat, callback, errorCallback){
    let url = "/calendar/admin/create"

    var bodyForm = new FormData()
    bodyForm.append("title", title)
    bodyForm.append("description", description)
    bodyForm.append("event_start", start)
    bodyForm.append("event_end", end)
    bodyForm.append("location", location)
    bodyForm.append("type", type)
    bodyForm.append("is_global", isGlobal)
    bodyForm.append("is_allday", isAllday)
    bodyForm.append("is_repeat", isRepeat)
    bodyForm.append("send_email", false)
    bodyForm.append('building_id', localStorage.getItem('building_id'))

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function updateCalendar(eventId, title, description, start, end, location, type, isGlobal, isAllday, isRepeat, callback, errorCallback){
    let url = "/calendar/admin/edit"

    var bodyForm = new FormData()
    bodyForm.append("event_id", eventId)
    bodyForm.append("title", title)
    bodyForm.append("description", description)
    bodyForm.append("event_start", start)
    bodyForm.append("event_end", end)
    bodyForm.append("location", location)
    bodyForm.append("type", type)
    bodyForm.append("is_global", isGlobal)
    bodyForm.append("is_allday", isAllday)
    bodyForm.append("is_repeat", isRepeat)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function addDepartmentEvent(eventId, departmentId, callback, errorCallback){
    let url = "/calendar/admin/addDepartment"

    var bodyForm = new FormData()
    bodyForm.append("event_id", eventId)
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeDepartmentEvent(eventId, departmentId, callback, errorCallback){
    let url = "/calendar/admin/removeDepartment"

    var bodyForm = new FormData()
    bodyForm.append("event_id", eventId)
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { 
    listCalendar, 
    getCalendar, 
    deleteCalendar, 
    createCalendar, 
    updateCalendar, 
    addDepartmentEvent, 
    removeDepartmentEvent
}